export const OnlineGivingEndpoints = {
    getClientAccessToken: () => '/online-giving/access/client',
};
